export default () => import(/* webpackChunkName: 'coffee/wechat-community/dice-coupon' */ './DiceCoupon');